import React from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import logo from "../images/logo.png";
import { FaXTwitter,FaFacebook,FaLinkedin } from "react-icons/fa6";

const Footer = () => {
  return (
    <>
      <footer>
       <div className="footer w-full bg-gray-100 border-t border-b">
 <div className="max-w-7xl mx-auto px-4 lg:px-8 py-8">
          {/* Top area: Blocks */}
         <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200">
            {/* 1st block */}
           <div className="col-span-12 lg:col-span-4 text-left">
              {/* <div className="box-border border-b-4 border-blue-900 p-8 bg-gray-200 text-gray-600 rounded-lg xl:w-80 mx-auto"> */}
              <Link to="/">
               <img
  src={logo}
  alt="QUADPROSOFT"
  className="w-[120px] sm:w-[140px] md:w-[155px] lg:w-[170px] h-auto object-contain"
/>
              </Link>
              {/* </div> */}
              {/* Social Media Links */}
              <div className="mt-6">
                <h6 className="text-base text-blue-900 font-bold mx-12 mb-4">
                  Follow us
                </h6>
               <div className="flex items-center gap-3 mt-4 mx-8">
  <a
    href="https://twitter.com/quadprosoft"
    target="_blank"
    rel="noopener noreferrer"
    className="group w-7 h-7 border border-gray-300 rounded-lg bg-white flex items-center justify-center shadow-sm hover:bg-[#153E75] hover:border-[#153E75] transition-all duration-300"
  >
    <FaXTwitter className="text-xl text-blue-900 group-hover:text-white " />
  </a>

  <a
    href="https://www.facebook.com/quadprosofttechnologiesinc"
    target="_blank"
    rel="noopener noreferrer"
    className="group w-7 h-7 border border-gray-300 rounded-lg bg-white flex items-center justify-center shadow-sm hover:bg-[#153E75] hover:border-[#153E75] transition-all duration-300"
  >
    <FaFacebook className="text-xl text-blue-900 group-hover:text-white" />
  </a>

  <a
    href="https://www.linkedin.com/company/quadprosoft-technologies"
    target="_blank"
    rel="noopener noreferrer"
    className="group w-7 h-7 border border-gray-300 rounded-lg bg-white flex items-center justify-center shadow-sm hover:bg-[#153E75] hover:border-[#153E75] transition-all duration-300"
  >
    <FaLinkedin className="text-xl text-blue-900 group-hover:text-white" />
  </a>
   {/* Instagram */}
                    {/* <li className="ml-4">
      <a
  href="#"
  target="_blank"
  rel="noopener noreferrer"
  className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out"
  aria-label="Instagram"
>
          <svg
            className="w-8 h-8 fill-current"
            viewBox="0 0 32 32"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M16 7c-2.6 0-2.9 0-3.9.1-.9 0-1.5.2-2 .4-.5.3-.9.6-1.3 1s-.7.8-1 1.3c-.2.4-.4 1-.4 2-.1 1-.1 1.4-.1 3.9s0 2.9.1 3.9c0 .9.2 1.5.4 2 .3.5.6.9 1 1.3s.8.7 1.3 1c.4.2 1 .4 2 .4 1 .1 1.4.1 3.9.1s2.9 0 3.9-.1c.9 0 1.5-.2 2-.4.5-.3.9-.6 1.3-1s.7-.8 1-1.3c.2-.4.4-1 .4-2 .1-1 .1-1.4.1-3.9s0-2.9-.1-3.9c0-.9-.2-1.5-.4-2-.3-.5-.6-.9-1-1.3s-.8-.7-1.3-1c-.4-.2-1-.4-2-.4-1-.1-1.4-.1-3.9-.1zm0-1.5c2.7 0 3.1 0 4.2.1 1.1.1 1.9.3 2.5.6.7.3 1.3.7 1.9 1.3.6.6 1 1.2 1.3 1.9.3.6.5 1.4.6 2.5.1 1.1.1 1.5.1 4.2s0 3.1-.1 4.2c-.1 1.1-.3 1.9-.6 2.5-.3.7-.7 1.3-1.3 1.9-.6.6-1.2 1-1.9 1.3-.6.3-1.4.5-2.5.6-1.1.1-1.5.1-4.2.1s-3.1 0-4.2-.1c-1.1-.1-1.9-.3-2.5-.6-.7-.3-1.3-.7-1.9-1.3-.6-.6-1-1.2-1.3-1.9-.3-.6-.5-1.4-.6-2.5C7 19.1 7 18.7 7 16s0-3.1.1-4.2c.1-1.1.3-1.9.6-2.5.3-.7.7-1.3 1.3-1.9.6-.6 1.2-1 1.9-1.3.6-.3 1.4-.5 2.5-.6 1.1-.1 1.5-.1 4.2-.1z" />
            <circle cx="16" cy="16" r="4.5" />
            <path d="M20.5 8.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5 1.5-.7 1.5-1.5-.7-1.5-1.5-1.5z" />
          </svg>
        </a>
      </li> */}
</div>
              </div>
            </div>

            {/* 2nd block */}
           <div className="col-span-6 md:col-span-6 lg:col-span-1 mx-auto lg:-ml-8">
              <h6 className="text-[#013289] text-base font-bold mb-3 whitespace-nowrap ">
                Useful Links
              </h6>
              <ul className="text-md">
                <li className="mb-2">
                  <HashLink
                    to="/"
                    className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    Home
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/about"
                    className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    About
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/careers"
                    className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    Careers
                  </HashLink>
                </li>
                <li className="mb-2">
                  <HashLink
                    to="/contact"
                    className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    Contact
                  </HashLink>
                </li>
              </ul>
            </div>

            {/* 3rd block */}
            <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
              <h6 className="text-[#013289] text-base font-bold mb-4">
                Our Services
              </h6>
              <ul className="text-md break-words">
                <li className="mb-2">
                  <Link
                    to="/accounting"
                    className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    Accounting
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/application-development"
                    className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    Application Development
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/consulting"
                    className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    Consulting
                  </Link>
                </li>
                <li className="mb-2">
                  <Link
                    to="/digital-marketing"
                    className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    Digital Marketing
                  </Link>
                </li>
                
                <li className="mb-2">
                  <Link
                    to="/staffing"
                   className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    Staffing & IT Solutions
                  </Link>
                </li>
                
                <li className="mb-2">
  <Link
    to="/digitalcommunication"
    className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
  >
    Digital Communication
  </Link>
</li>
        <li className="mb-2">
                  <Link
                    to="/telecommunications"
                   className="inline-block text-[#013289] hover:text-blue-500 transition-all duration-300 hover:scale-110 origin-left"
                  >
                    Telecommunications
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-span-6 md:col-span-6 lg:col-span-3 ml-7 mx-auto">
              <h6 className="text-[#013289] text-base font-bold mb-2">
                Address
              </h6>

              <h6 className="text-[#013289] text-base font-bold mb-2">US</h6>
              <p className="text-sm">
              Mail Box 1298, <br/>
              505 20th St North, <br />
              Suite 1220, Birmingham, AL - 35203. <br />
              United States <br />
                <strong>Phone:</strong>
                <a href="tel:"> +1 (205)-941-8432</a> <br />
              </p>

              {/* 5th block: India Address */}
              <h6 className="text-[#013289] text-base font-bold mb-2 mt-3">
                India
              </h6>
              <p className="text-sm">
                No 31, Vandavasi Road, <br />
                Vedachala Nagar,
                <br />
                Kanchipuram, TamilNadu, 631502.
                <br />
                India
                <br />
                <strong>Phone:</strong>
                <a href="tel:"> +91 8015801544</a> <br />
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto">
            <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
              <div className="text-sm text-gray-200 font-semibold py-1">
                &copy; Copyright 2024.
                {/* {new Date().getFullYear()}{" "} */}
                <HashLink to="#" className="hover:text-gray-900">
                  Quadprosoft Technologies Inc
                </HashLink>
                . All rights reserved.
              </div>
            </div>
          </div>
       </div>   {/* max-w-7xl wrapper close */}
</div>   {/* footer close */}
      </footer>
    </>
  );
};
export default Footer;
